export const resourcesNotIncludedInScheduleSelect = new Set([
  "eks_ec2",
  "gke_vm",
  "node_pool",
  "node_group",
  "az_aks_vm",
  "az_node_pool",
]);
